import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, withStyles } from '@material-ui/core';
import { CART_TAB_CIP, CART_TAB_CGS } from '../constant';

const styles = () => ({
  tabIndicator: {
    display: 'none',
  },
  tabRoot: {
    marginBottom: '20px',
    overflow: 'visible',
  },
  tabElement: {
    backgroundColor: 'rgba(200, 200, 200, 0.2)',
    textTransform: 'capitalize',
  },
  tabElementActive: {
    backgroundColor: '#3f51b5',
    color: '#ffffff !important',
    transform: 'scaleY(1.1)',
    borderRadius: '4px',
    boxShadow: '0px 4px 20px rgba(0, 102, 203, 0.45)',
  },
  tabScroller: {
    overflowX: 'visible',
  },
});

const CipCgsTabs = ({
  classes,
  selectedTab,
  onTabPressed,
}) => (
  <Tabs
    value={selectedTab}
    indicatorColor="primary"
    textColor="primary"
    classes={{
      root: classes.tabRoot,
      indicator: classes.tabIndicator,
      scroller: classes.tabScroller,
    }}
    fullWidth
    centered
  >
    <Tab
      value={CART_TAB_CIP}
      label={CART_TAB_CIP}
      classes={{
        root: classes.tabElement,
        selected: classes.tabElementActive,
      }}
      onClick={() => onTabPressed(CART_TAB_CIP)}
    />
    <Tab
      value={CART_TAB_CGS}
      label={CART_TAB_CGS}
      classes={{
        root: classes.tabElement,
        selected: classes.tabElementActive,
      }}
      onClick={() => onTabPressed(CART_TAB_CGS)}
    />
  </Tabs>
);

CipCgsTabs.propTypes = {
  classes: PropTypes.shape(PropTypes.any).isRequired,
  selectedTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onTabPressed: PropTypes.func.isRequired,
};

export default withStyles(styles)(CipCgsTabs);
